import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './LogisticsPage.less';

export default class LogisticsPage extends OfficialPage {
  state = {
    info: {},
    logistics: []
  }
  orderId = ''
  applyId = ''
  franchiseeId = ''
  isGroup = 0

  constructor(props) {
    super(props);
    document.title = '物流信息';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let form = options.form
    this.orderId = options.detail
    this.applyId = options.applyId
    this.franchiseeId = options.franchiseeId || ''
    this.isGroup = options.isGroup || 0
    if (form == 'afterSale') {
      this.getRefundExpress()
    } else {
      this.getExpressFlow()
    }
  }

  getExpressFlow = () => {
    let _this = this
    let data = {
      order_id: _this.orderId,
      sub_shop_app_id: _this.franchiseeId
    }
    let url = '/index.php?r=AppShop/expressFlow'
    if (this.isGroup) {
      url = '/index.php?r=AppDistributionExt/GetGroupExpressFlow'
      data = {
        app_id: _this.franchiseeId,
        group_order_id: _this.orderId
      }
    }
    app.sendRequest({
      url: url,
      data: data,
      success: function (res) {
        let info = res.data
        if (!info) {
          return
        }
        if (info.is_custom) {
          let description = info.express_description.replace(/]/g, '[')
          let desArr = description.split('[')
          _this.setData({
            info: info,
            desArr: desArr
          })
        } else {
          let logistics = info.Traces
          if (info.waybill_id) {
            info.path_item_list.map(item => {
              item.AcceptTime = item.action_time
              item.AcceptStation = item.action_msg
            })
            logistics = info.path_item_list
          }
          _this.setData({
            info: info,
            logistics: logistics
          })
        }
      }
    })
  }
  getRefundExpress = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/getRefundExpress',
      data: {
        apply_id: _this.applyId,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        _this.setData({
          info: res.data,
          logistics: res.data.Traces.reverse()
        })
      }
    })
  }
  dialNumber = event => {
    app.makePhoneCall(event.currentTarget.dataset.phone)
  }

  render() {
    const { showGetUserInfo, info, desArr, logistics } = this.state
    return (
      <div className="official-page logistics-page">
        <TopNav title="物流信息" />
        <div id="logisticsPage">
          <div className="logistics-header">
            <div className="logistics-company">
              承运公司：<span>{info.express_name || info.delivery_name}</span>
            </div>
            <div>
              运单编号：
              <span>
                {info.LogisticCode || info.express_no || info.waybill_id}
              </span>
            </div>
          </div>
          {(info.is_custom && desArr.length) ||
            (!info.is_custom && logistics.length) ? (
              <div className="logistics-container">
                {info.is_custom ? (
                  <React.Fragment>
                    {desArr.map((item, index) => {
                      return (
                        <span
                          key={index}
                          className={
                            'self-express ' +
                            (index % 2 == 1 ? 'express-phone' : '')
                          }
                          onClick={index % 2 == 1 ? 'dialNumber' : ''}
                          data-phone={item}
                        >
                          {index % 2 == 1 ? '[' + item + ']' : item}
                        </span>
                      )
                    })}
                  </React.Fragment>
                ) : (
                    <React.Fragment>
                      <div className="logistics-list">
                        {logistics.map((item, index) => {
                          return (
                            <div key={index} className="logistics-item">
                              <div className="logistics-location">
                                {item.AcceptStation}
                              </div>
                              <div className="logistics-time">
                                {item.AcceptTime}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </React.Fragment>
                  )}
              </div>
            ) : (
              <div className="no-logistics">
                <img src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-logistics.png" />
                <div>暂无物流信息</div>
              </div>
            )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/logistics-page/LogisticsPage.jsx